import React from 'react'
import { render } from 'react-dom'
import { Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import { ConnectedRouter, routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import logger from 'redux-logger'
import 'dbrain-web-ui-lib/dist/style.css'
import { App } from './components'
import reducers from './reducers'
import history from './history'

const middlewares = [thunk, routerMiddleware(history)]
if (!PRODUCTION) {
	middlewares.push(logger)
}
const store = createStore(reducers, applyMiddleware(...middlewares))


render(
	(
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<Route path="/" component={App} />
			</ConnectedRouter>
		</Provider>
	), document.getElementById('root'),
)
